import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap';
import { InterviewStatusChange } from '../../../Services/interviewService';
import { InterviewHistoryAction } from '../../../Redux/action/InterviewHistoryAction';
import { useDispatch, useSelector } from 'react-redux';

const ChangeInterviewStatus = ({ id, setAnchorEl, pageNumber }) => {
    const [modal, setModal] = useState(false);
    const [isloading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const { userResult } = useSelector((state) => state.Auth);
    let vendorid = userResult?.vendorid;
    const handleChangeStatus = () => {
        InterviewStatusChange(id).then((res) => {
            setModal(false);
            setAnchorEl(false)
        }).finally(() => {
            setIsLoading(false);
            dispatch(InterviewHistoryAction(vendorid, pageNumber));
        })
    }

    return (
        <div>
            <div style={{ cursor: "pointer" }} onClick={() => { setModal(true); }}>change status</div>
            <Modal
                show={modal}
                onHide={() => { setModal(false) }}
                backdrop="static"
                keyboard={false}
                style={{ top: "30%", zIndex: 999999 }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Change Status</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Do you want to change status to next round?
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button
                        disabled={isloading}
                        className="btn-lg btn-primary-custom"
                        onClick={handleChangeStatus}
                    >
                        {isloading ? "Loading..." : "Yes"}
                    </Button>
                    <Button className="btn-lg btn-primary-custom" onClick={() => { setModal(false); }}>
                        No
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ChangeInterviewStatus
